// Translation dictionary FR/EN for GPE Énergies & Services

export const translations = {
  // =========================================================
  // FRENCH
  // =========================================================
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos de nous',
      services: 'Services',
      references: 'Références',
      international: 'International',
      contact: 'Contact',
      cta: 'Demander un devis',
      openMenu: 'Menu',
    },

    common: {
      learnMore: 'En savoir plus',
      requestQuote: 'Demander un devis',
      contactUs: 'Nous contacter',
      callUs: 'Nous appeler',
      backToServices: 'Tous nos services',
      viewAll: 'Voir tous',
      allProjects: 'Tous les projets',
      partners: 'Partenaires',
      certifications: 'Certifications',
      relatedServices: 'Services complémentaires',
    },

    // =========================================================
    // HERO
    // =========================================================
    hero: {
      pill: 'GPE · ÉNERGIES & SERVICES',

      titleA: 'L’énergie qui',

      titleAccent: 'donne vie',

      titleB: 'à vos propriétés.',

      subtitle:
        'Énergies renouvelables, solutions solaires et bornes de recharge : votre avenir, notre expertise.',

      ctaContact: 'Contactez-nous',

      ctaServices: 'Nos Services',

      stats: [
        {
          value: '10+',
          label: "Des années d'expérience",
        },
        {
          value: '150+',
          label: 'Clients satisfaits',
        },
        {
          value: '8',
          label: "Domaines d'expertise",
        },
        {
          value: '100%',
          label: 'Satisfaction client',
        },
      ],
    },

    // =========================================================
    // STORY / ABOUT
    // =========================================================
    story: {
      badge: '+ À PROPOS DE NOUS',

      titleA: 'Électricité des bâtiments',

      titleAccent: 'et des habitations.',

      p1:
        'GPE – ENERGIES & SERVICES est une entreprise spécialisée dans un large éventail de domaines, offrant des solutions d’avenir pour un approvisionnement énergétique durable.',

      p2:
        'Dans le secteur tertiaire et industriel, nous accompagnons nos clients avec des solutions techniques et économiques pour maximiser leur efficacité et réduire leurs coûts. Grâce à notre expertise dans les énergies renouvelables, telles que les systèmes solaires et les bornes de recharge pour véhicules électriques, nous proposons des solutions sur mesure pour aider les entreprises et les particuliers à passer à des sources d’énergie respectueuses de l’environnement.',

      features: [
        {
          title: 'Maîtrise électrique',
          desc:
            "Spécialistes de la gestion et de l’exploitation de réseaux d’infrastructures diverses.",
        },
        {
          title: 'Solutions durables',
          desc:
            "Solutions d’avenir pour un approvisionnement énergétique durable, grâce aux énergies renouvelables.",
        },
        {
          title: 'Sur mesure',
          desc:
            "Solutions techniques et économiques adaptées aux secteurs tertiaire et industriel.",
        },
      ],

      bottomStats: [
        {
          value: '150+',
          label: 'CLIENTS SATISFAITS',
        },
        {
          value: '10+',
          label: 'EMPLOYÉS',
        },
        {
          value: '10+',
          label: 'ANNÉES D’EXPÉRIENCE',
        },
      ],
    },
    // =========================================================
    // PROJECTS / REFERENCES
    // =========================================================
    // =========================================================
    // SERVICES
    // =========================================================
    services: {
      'courants-forts': {
        title: 'Courants forts',
        desc: 'Distribution électrique, tableaux BT/HT, éclairage et équipements de puissance pour bâtiments tertiaires et industriels.',
      },
      'courants-faibles': {
        title: 'Courants faibles',
        desc: 'Sûreté, contrôle d’accès, réseaux VDI, vidéosurveillance et systèmes de communication pour vos infrastructures.',
      },
      'energies-renouvelables': {
        title: 'Énergies renouvelables',
        desc: 'Solutions photovoltaïques et stockage batterie pour accélérer votre transition énergétique vers des sources durables.',
      },
      'mobilite-electrique': {
        title: 'Mobilité électrique',
        desc: 'Bornes de recharge pour véhicules électriques : de la wallbox résidentielle aux stations rapides en réseau (IRVE).',
      },
      'renovation-energetique': {
        title: 'Rénovation énergétique',
        desc: 'Audit, conseil et travaux de rénovation pour réduire la consommation et valoriser durablement vos bâtiments.',
      },
      'chauffage-climatisation': {
        title: 'Chauffage et climatisation',
        desc: 'Solutions CVC complètes : pompes à chaleur, climatisation et ventilation, de l’installation à la maintenance.',
      },
      'vrd': {
        title: 'VRD (Voiries et Réseaux Divers)',
        desc: 'Voiries, réseaux divers et aménagements extérieurs : terrassement, drainage et infrastructures de site.',
      },
      'bureau-etudes': {
        title: "Bureau d'études",
        desc: 'Ingénierie électrique, conception, dimensionnement et suivi de chantier au service de vos projets énergétiques.',
      },
    },

    projectsSection: {
      badge: '+ NOS RÉFÉRENCES',

      titleA: 'Ils nous font',

      titleAccent: 'confiance.',

      subtitle:
        'De grands groupes du bâtiment, des télécoms et de l’énergie nous confient leurs projets partout en France.',

      viewAll: 'Voir toutes les références',

      discover: 'Découvrir tous nos projets',
    },

    // =========================================================
    // CERTIFICATIONS
    // =========================================================
    certifications: {
      tagline: 'GPE ÉNERGIES & SERVICES',

      titleA: 'Nos',

      titleAccent: 'certifications',
    },
        // =========================================================
    // FOOTER
    // =========================================================
    footer: {
      about:
        "L’énergie qui donne vie à vos propriétés. Expert en installations électriques, énergies renouvelables et solutions CVC.",

      navigation: 'Navigation',

      services: 'Nos Services',

      contact: 'Contact',

      response: 'Réponse sous 24h ouvrées',

      rights: 'Tous droits réservés.',

      legal: 'Mentions légales',

      privacy: 'Politique de confidentialité',

      cookies: 'Cookies',
    },

    // CONTACT
    // =========================================================
    contact: {
      pill: 'CONTACT',

      titleA: 'Parlons de',

      titleAccent: 'votre projet.',

      subtitle:
        "Notre équipe répond sous 24h ouvrées. Que ce soit pour un devis, une étude de faisabilité ou une question technique, nous sommes à votre écoute.",

      phone: 'Téléphone',

      email: 'Email',

      address: 'Adresse',

      hours: 'Horaires',

      weekdays: 'Lundi – Vendredi',

      weekend: 'Samedi – Dimanche',

      closed: 'Fermé',

      responseTitle: 'Réponse sous 24h ouvrées',

      responseSub: 'Un conseiller dédié vous rappelle rapidement.',

      formBadge: 'GPE – ÉNERGIES & SERVICES',

      formTitleA: 'Contactez-',

      formTitleAccent: 'nous.',

      formSub:
        'Remplissez ce formulaire, nous revenons vers vous sous 24h ouvrées.',

      fullName: 'Nom complet',

      emailLabel: 'Email',

      phoneLabel: 'Téléphone',

      company: 'Société',

      service: 'Service concerné',

      selectService: 'Sélectionnez un service',

      otherRequest: 'Autre demande',

      yourMessage: 'Votre message',

      messagePlaceholder:
        'Décrivez votre projet ou votre demande…',

      send: 'Envoyer le message',

      success:
        'Message envoyé avec succès. Nous vous répondrons rapidement.',

      policy:
        'En envoyant ce formulaire, vous acceptez notre politique de confidentialité.',
    },

    // =========================================================
    // INTERNATIONAL
    // =========================================================
    international: {
      pill: 'PRÉSENCE MONDIALE',

      titleA: 'Au-delà',

      titleAccent: 'des frontières.',

      subtitle:
        'GPE Énergies & Services accompagne des projets d’envergure en France et à l’international, en apportant son expertise technique en électricité et énergies renouvelables sur chaque continent.',

      stats: [
        {
          value: '2',
          label: 'Continents',
        },
        {
          value: '2+',
          label: 'Pays couverts',
        },
        {
          value: '150+',
          label: 'Projets livrés',
        },
        {
          value: '10+',
          label: 'Partenaires internationaux',
        },
      ],
    },

    // =========================================================
    // REFERENCES
    // =========================================================
    references: {
      pill: 'NOS RÉFÉRENCES',

      titleA: 'Des projets qui',

      titleAccent: 'parlent d’eux-mêmes.',

      subtitle:
        'Plus de 500 projets réalisés pour des maîtres d’ouvrage publics et privés partout en France.',

      featuredBadge: '+ PROJETS VEDETTES',

      featuredTitleA: 'Nos réalisations',

      featuredTitleAccent: 'phares',

      featuredSub:
        'Une sélection de nos projets les plus emblématiques, reflet de notre savoir-faire terrain.',

      partnersTagline: 'GPE – ÉNERGIES & SERVICES',

      partnersTitleA: 'Eux aussi nous font',

      partnersTitleAccent: 'confiance',

      partnersSub:
        'De grands groupes du bâtiment, des télécoms et de l’énergie nous confient leurs projets.',

      ctaTitle: 'Un projet similaire ?',

      ctaSub:
        'Discutons de votre projet. Notre équipe d’experts vous répond sous 24h ouvrées.',
    },
about: {
  heroTitleA: 'À propos',
  heroTitleAccent: 'de nous',
  heroSubtitle:
    'Votre partenaire de confiance en énergies renouvelables et en infrastructures électriques.',

  companyBadge: '+ NOTRE ENTREPRISE',
  companyTitleA: 'Experts en énergie',
  companyTitleAccent: 'depuis plus d’une décennie',
  companyTitleEnd: '.',

  companyP1:
    'GPE – ÉNERGIES & SERVICES est une entreprise spécialisée dans un large éventail de domaines, offrant des solutions d’avenir pour un approvisionnement énergétique durable.',

  bullet1: 'Installations photovoltaïques et énergies renouvelables',
  bullet2: 'Travaux électriques industriels et tertiaires',
  bullet3: 'Infrastructure de recharge pour véhicules électriques',

  companyP2:
    'Nous accompagnons nos clients avec des solutions techniques et économiques fiables, conçues pour répondre aux enjeux énergétiques d’aujourd’hui et de demain.',

  contactButton: 'Contactez-nous',

  missionTitle: 'Notre mission',
  missionText:
    'Accompagner nos clients dans leur transition énergétique avec des solutions techniques fiables et sur mesure – de la conception à la mise en service.',

  yearsExperience: 'Années d’expérience',
  partners: 'Partenaires',

  nationalPresence: 'Présence nationale',
  locations: 'Vitrolles · Paris · Lyon · Marseille',

  figuresBadge: '+ CHIFFRES CLÉS',
  figuresTitleA: 'Des résultats qui',
  figuresTitleAccent: 'parlent',

  clientsLabel: 'Clients satisfaits',
  clientsDesc:
    'Des professionnels et des particuliers qui nous font confiance dans toute la France.',

  projectsLabel: 'Projets réalisés',
  projectsDesc:
    'Plus de 500 projets livrés avec succès dans le tertiaire, l’industrie et le résidentiel.',

  growthValue: 'Croissance',
  growthLabel: 'Maîtrisée et durable',
  growthDesc:
    'Une croissance structurée qui reflète la confiance renouvelée de nos clients.',

  capabilitiesBadge: '+ ORGANISATION & RESSOURCES',
  capabilitiesTitleA: 'Nos capacités &',
  capabilitiesTitleAccent: 'expertise',
  capabilitiesSubtitle:
    'Des ressources humaines et techniques dédiées à l’excellence sur chacun de vos projets.',

  engineeringTitle: "Bureau d'études intégré",
  engineeringDesc:
    "Conception, dimensionnement et suivi technique des projets, de l’étude initiale à la mise en service.",

  certifiedTitle: 'Équipes techniques certifiées',
  certifiedDesc:
    'Suivi opérationnel de vos chantiers assuré par des équipes qualifiées et certifiées.',

  solarTitle: 'Équipes photovoltaïques',
  solarDesc:
    'Installateurs spécialisés en photovoltaïque pour des déploiements rapides et conformes RGE.',

  electricalTitle: 'Équipes électriques',
  electricalDesc:
    'Spécialistes des travaux électriques commerciaux et industriels sur réseaux BT et HT.',

  irveTitle: 'Équipes IRVE',
  irveDesc:
    'Équipes IRVE certifiées dédiées aux infrastructures de recharge pour véhicules électriques.',

  ctaTitleA: 'Vous avez un projet',
  ctaTitleAccent: 'en tête',
  ctaText:
    'Notre équipe est prête à étudier votre projet et à vous proposer une solution sur mesure, de la conception à la mise en service.',

  quoteButton: 'Demander un devis',
},
    // =========================================================
    // SERVICES PAGE
    // =========================================================
    servicesPage: {
      pill: 'GPE · ÉNERGIES & SERVICES',

      titleA: 'Des solutions complètes',

      titleAccent: 'pour vos projets énergétiques.',

      subtitle:
        'Nous accompagnons les entreprises, collectivités et industries avec des solutions fiables, innovantes et durables.',

      sectionTagline: 'GPE · ÉNERGIES & SERVICES',

      sectionTitleA: 'Nos',

      sectionTitleAccent: 'Services',

      sectionSub:
        'Une offre complète pour répondre à tous vos besoins en électricité, énergies renouvelables et performance énergétique.',

      projectTitle: 'Vous avez un projet ?',

      projectSub:
        'Notre équipe d’experts est à votre disposition pour étudier vos besoins et vous proposer une solution adaptée.',

      trustTitleA: 'Eux aussi nous font',

      trustTitleAccent: 'confiance…',
    },

    // =========================================================
    // SUB SERVICE
    // =========================================================
    subService: {
      badge: 'NOTRE EXPERTISE',

      heading: 'Ce que nous réalisons pour vous',

      methodology: 'Méthodologie & accompagnement',

      solutions: 'Nos solutions',

      sectors: 'Secteurs d’intervention',

      quoteTitle: 'Un projet ?',

      quoteSub:
        'Obtenez une étude personnalisée et un devis gratuit sous 24h.',
    },

    // =========================================================
    // ABOUT PAGE
    // =========================================================
    about: {
      pill: '+ NOTRE ENTREPRISE',

      titleA: 'Experts en énergie',

      titleAccent: 'depuis plus d’une décennie',

      intro:
        'GPE – ÉNERGIES & SERVICES est une entreprise spécialisée dans un large éventail de domaines, offrant des solutions d’avenir pour un approvisionnement énergétique durable.',

      bullets: [
        'Installations photovoltaïques et énergies renouvelables',
        'Travaux électriques industriels et tertiaires',
        'Infrastructure de recharge pour véhicules électriques',
      ],

      p2:
        'Nous accompagnons nos clients avec des solutions techniques et économiques fiables, conçues pour répondre aux enjeux énergétiques d’aujourd’hui et de demain.',

      contact: 'Contactez-nous',

      missionTitle: 'Notre mission',

      missionText:
        'Accompagner nos clients dans leur transition énergétique avec des solutions techniques fiables et sur mesure – de la conception à la mise en service.',

      years: 'Années d’expérience',

      partners: 'Partenaires',

      presence: 'Présence nationale',

      figuresBadge: '+ CHIFFRES CLÉS',

      figuresTitleA: 'Des résultats qui',

      figuresTitleAccent: 'parlent',

      capBadge: '+ ORGANISATION & RESSOURCES',

      capTitleA: 'Nos capacités &',

      capTitleAccent: 'expertise',

      capSub:
        'Des ressources humaines et techniques dédiées à l’excellence sur chacun de vos projets.',

      ctaTitleA: 'Vous avez un projet',

      ctaTitleAccent: 'en tête',

      ctaSub:
        'Notre équipe est prête à étudier votre projet et à vous proposer une solution sur mesure, de la conception à la mise en service.',
    },
  },

  // =========================================================
  // ENGLISH
  // =========================================================
  en: {
    nav: {
      home: 'Home',
      about: 'About us',
      services: 'Services',
      references: 'References',
      international: 'International',
      contact: 'Contact',
      cta: 'Request a quote',
      openMenu: 'Menu',
    },

    common: {
      learnMore: 'Learn more',
      requestQuote: 'Request a quote',
      contactUs: 'Contact us',
      callUs: 'Call us',
      backToServices: 'All our services',
      viewAll: 'View all',
      allProjects: 'All projects',
      partners: 'Partners',
      certifications: 'Certifications',
      relatedServices: 'Related services',
    },

    // =========================================================
    // HERO
    // =========================================================
    hero: {
      pill: 'GPE · ENERGIES & SERVICES',

      titleA: 'The energy that brings',

      titleAccent: 'life',

      titleB: 'to your properties.',

      subtitle:
        'Specialists in the management and operation of diverse infrastructure networks. Future-ready solutions for sustainable energy, for professionals and individuals alike.',

      ctaContact: 'Contact us',

      ctaServices: 'Our Services',

      stats: [
        {
          value: '10+',
          label: 'Years of experience',
        },
        {
          value: '150+',
          label: 'Satisfied clients',
        },
        {
          value: '8',
          label: 'Areas of expertise',
        },
        {
          value: '100%',
          label: 'Client satisfaction',
        },
      ],
    },

    // =========================================================
    // STORY / ABOUT
    // =========================================================
    story: {
      badge: '+ ABOUT US',

      titleA: 'Electricity for buildings',

      titleAccent: 'and homes.',

      p1:
        'GPE – ENERGIES & SERVICES is a company specialised in a wide range of fields, offering forward-looking solutions for a sustainable energy supply.',

      p2:
        'In the tertiary and industrial sectors, we support our clients with technical and cost-effective solutions to maximise efficiency and reduce operating costs. Thanks to our expertise in renewables such as solar systems and EV charging stations, we deliver tailor-made solutions to help businesses and individuals switch to environmentally friendly sources.',

      features: [
        {
          title: 'Electrical mastery',
          desc:
            'Specialists in managing and operating diverse infrastructure networks.',
        },
        {
          title: 'Sustainable solutions',
          desc:
            'Future-ready solutions for a sustainable energy supply, powered by renewables.',
        },
        {
          title: 'Tailor-made',
          desc:
            'Technical and cost-effective solutions adapted to the tertiary and industrial sectors.',
        },
      ],

      bottomStats: [
        {
          value: '150+',
          label: 'SATISFIED CLIENTS',
        },
        {
          value: '10+',
          label: 'EMPLOYEES',
        },
        {
          value: '10+',
          label: 'YEARS OF EXPERIENCE',
        },
      ],
    },
about: {
  heroTitleA: 'À propos',
  heroTitleAccent: 'de nous',
  heroSubtitle:
    'Votre partenaire de confiance en énergies renouvelables et en infrastructures électriques.',

  companyBadge: '+ NOTRE ENTREPRISE',
  companyTitleA: 'Experts en énergie',
  companyTitleAccent: 'depuis plus d’une décennie',
  companyTitleEnd: '.',

  companyP1:
    'GPE – ÉNERGIES & SERVICES est une entreprise spécialisée dans un large éventail de domaines, offrant des solutions d’avenir pour un approvisionnement énergétique durable.',

  bullet1: 'Installations photovoltaïques et énergies renouvelables',
  bullet2: 'Travaux électriques industriels et tertiaires',
  bullet3: 'Infrastructure de recharge pour véhicules électriques',

  companyP2:
    'Nous accompagnons nos clients avec des solutions techniques et économiques fiables, conçues pour répondre aux enjeux énergétiques d’aujourd’hui et de demain.',

  contactButton: 'Contactez-nous',

  missionTitle: 'Notre mission',
  missionText:
    'Accompagner nos clients dans leur transition énergétique avec des solutions techniques fiables et sur mesure – de la conception à la mise en service.',

  yearsExperience: 'Années d’expérience',
  partners: 'Partenaires',

  nationalPresence: 'Présence nationale',
  locations: 'Vitrolles · Paris · Lyon · Marseille',

  figuresBadge: '+ CHIFFRES CLÉS',
  figuresTitleA: 'Des résultats qui',
  figuresTitleAccent: 'parlent',

  clientsLabel: 'Clients satisfaits',
  clientsDesc:
    'Des professionnels et des particuliers qui nous font confiance dans toute la France.',

  projectsLabel: 'Projets réalisés',
  projectsDesc:
    'Plus de 500 projets livrés avec succès dans le tertiaire, l’industrie et le résidentiel.',

  growthValue: 'Croissance',
  growthLabel: 'Maîtrisée et durable',
  growthDesc:
    'Une croissance structurée qui reflète la confiance renouvelée de nos clients.',

  capabilitiesBadge: '+ ORGANISATION & RESSOURCES',
  capabilitiesTitleA: 'Nos capacités &',
  capabilitiesTitleAccent: 'expertise',
  capabilitiesSubtitle:
    'Des ressources humaines et techniques dédiées à l’excellence sur chacun de vos projets.',

  engineeringTitle: "Bureau d'études intégré",
  engineeringDesc:
    "Conception, dimensionnement et suivi technique des projets, de l’étude initiale à la mise en service.",

  certifiedTitle: 'Équipes techniques certifiées',
  certifiedDesc:
    'Suivi opérationnel de vos chantiers assuré par des équipes qualifiées et certifiées.',

  solarTitle: 'Équipes photovoltaïques',
  solarDesc:
    'Installateurs spécialisés en photovoltaïque pour des déploiements rapides et conformes RGE.',

  electricalTitle: 'Équipes électriques',
  electricalDesc:
    'Spécialistes des travaux électriques commerciaux et industriels sur réseaux BT et HT.',

  irveTitle: 'Équipes IRVE',
  irveDesc:
    'Équipes IRVE certifiées dédiées aux infrastructures de recharge pour véhicules électriques.',

  ctaTitleA: 'Vous avez un projet',
  ctaTitleAccent: 'en tête',
  ctaText:
    'Notre équipe est prête à étudier votre projet et à vous proposer une solution sur mesure, de la conception à la mise en service.',

  quoteButton: 'Demander un devis',
},
    // =========================================================
    // SERVICES SECTION
    // =========================================================
    servicesSection: {
      badge: '+ OUR EXPERTISE',

      titleA: 'Complete solutions,',

      titleB: 'from design to delivery.',

      subtitle:
        'Eight complementary trades to answer all your energy and building needs.',
    },

    // =========================================================
    // PROJECTS / REFERENCES
    // =========================================================
    // =========================================================
    // SERVICES
    // =========================================================
    services: {
      'courants-forts': {
        title: 'Power systems',
        desc: 'Electrical distribution, LV/MV switchboards, lighting and power equipment for commercial and industrial buildings.',
      },
      'courants-faibles': {
        title: 'Low-voltage systems',
        desc: 'Security, access control, VDI networks, video surveillance and communication systems for your infrastructure.',
      },
      'energies-renouvelables': {
        title: 'Renewable energy',
        desc: 'Photovoltaic solutions and battery storage to accelerate your transition towards sustainable energy sources.',
      },
      'mobilite-electrique': {
        title: 'Electric mobility',
        desc: 'Electric vehicle charging solutions, from residential wallboxes to fast-charging network stations.',
      },
      'renovation-energetique': {
        title: 'Energy renovation',
        desc: 'Energy audits, consulting and renovation works to reduce consumption and sustainably enhance your buildings.',
      },
      'chauffage-climatisation': {
        title: 'Heating & air conditioning',
        desc: 'Complete HVAC solutions including heat pumps, air conditioning and ventilation, from installation to maintenance.',
      },
      'vrd': {
        title: 'Roads & Utilities',
        desc: 'Roads, utility networks and external development works including earthworks, drainage and site infrastructure.',
      },
      'bureau-etudes': {
        title: 'Engineering office',
        desc: 'Electrical engineering, design, sizing and construction monitoring for your energy projects.',
      },
    },

    projectsSection: {
      badge: '+ OUR REFERENCES',

      titleA: 'They trust',

      titleAccent: 'us.',

      subtitle:
        'Major building, telecom and energy groups entrust us with their projects across France.',

      viewAll: 'See all references',

      discover: 'Discover all our projects',
    },

       // =========================================================
    // CERTIFICATIONS
    // =========================================================
    certifications: {
      tagline: 'GPE ÉNERGIES & SERVICES',

      titleA: 'Nos',

      titleAccent: 'certifications',
    },

    // =========================================================
    // FOOTER
    // =========================================================
    footer: {
      about:
        'The energy that brings life to your properties. Experts in electrical installations, renewable energies and HVAC solutions.',

      navigation: 'Navigation',

      services: 'Our Services',

      contact: 'Contact',

      response: 'Response within 24 business hours',

      rights: 'All rights reserved.',

      legal: 'Legal notice',

      privacy: 'Privacy policy',

      cookies: 'Cookies',
    },
    // =========================================================
    // CONTACT
    // =========================================================
    contact: {
      pill: 'CONTACT',

      titleA: 'Let’s talk about',

      titleAccent: 'your project.',

      subtitle:
        'Our team replies within 24 business hours. For a quote, a feasibility study or a technical question, we’re here to listen.',

      phone: 'Phone',

      email: 'Email',

      address: 'Address',

      hours: 'Hours',

      weekdays: 'Monday – Friday',

      weekend: 'Saturday – Sunday',

      closed: 'Closed',

      responseTitle: 'Response within 24 business hours',

      responseSub: 'A dedicated advisor will call you back quickly.',

      formBadge: 'GPE – ENERGIES & SERVICES',

      formTitleA: 'Contact',

      formTitleAccent: 'us.',

      formSub:
        'Fill out this form, we’ll get back to you within 24 business hours.',

      fullName: 'Full name',

      emailLabel: 'Email',

      phoneLabel: 'Phone',

      company: 'Company',

      service: 'Service',

      selectService: 'Select a service',

      otherRequest: 'Other request',

      yourMessage: 'Your message',

      messagePlaceholder:
        'Describe your project or request…',

      send: 'Send message',

      success:
        'Message sent successfully. We’ll reply shortly.',

      policy:
        'By submitting this form you accept our privacy policy.',
    },

    // =========================================================
    // INTERNATIONAL
    // =========================================================
    international: {
      pill: 'GLOBAL PRESENCE',

      titleA: 'Beyond',

      titleAccent: 'borders.',

      subtitle:
        'GPE Energies & Services supports large-scale projects across France and internationally, delivering technical expertise in electricity and renewables on every continent.',

      stats: [
        {
          value: '2',
          label: 'Continents',
        },
        {
          value: '2+',
          label: 'Countries covered',
        },
        {
          value: '150+',
          label: 'Projects delivered',
        },
        {
          value: '10+',
          label: 'International partners',
        },
      ],

      officesBadge: '+ OUR OFFICES',

      officesTitleA: 'A presence across',

      officesTitleAccent: '2 continents',

      officesSub:
        'Our teams operate from France and Saudi Arabia to cover Europe and the Gulf.',

      partnersBadge: '+ INTERNATIONAL PARTNERS',

      partnersTitleA: 'Strategic',

      partnersTitleAccent: 'alliances',

      certificationsBadge: 'CERTIFICATIONS & QUALIFICATIONS',

      certificationsTitleA: 'Certified. Recognised.',

      certificationsTitleAccent: 'Reliable.',

      ctaTitle: 'An international project?',

      ctaSub:
        'Contact the nearest office to study your project, on any continent.',

      hq: 'Head office',

      regional: 'Regional office – Gulf',
    },

    // =========================================================
    // REFERENCES
    // =========================================================
    references: {
      pill: 'OUR REFERENCES',

      titleA: 'Projects that',

      titleAccent: 'speak for themselves.',

      subtitle:
        'Over 500 projects delivered for public and private clients across France.',

      featuredBadge: '+ FEATURED PROJECTS',

      featuredTitleA: 'Our flagship',

      featuredTitleAccent: 'achievements',

      featuredSub:
        'A selection of our most emblematic projects, reflecting our field expertise.',

      partnersTagline: 'GPE – ENERGIES & SERVICES',

      partnersTitleA: 'They also trust',

      partnersTitleAccent: 'us',

      partnersSub:
        'Major building, telecom and energy groups entrust us with their projects.',

      ctaTitle: 'A similar project?',

      ctaSub:
        'Let’s discuss your project. Our team of experts replies within 24 business hours.',
    },

    // =========================================================
    // SERVICES PAGE
    // =========================================================
    servicesPage: {
      pill: 'GPE · ENERGIES & SERVICES',

      titleA: 'Complete solutions',

      titleAccent: 'for your energy projects.',

      subtitle:
        'We support companies, local authorities and industries with reliable, innovative and sustainable solutions.',

      sectionTagline: 'GPE · ENERGIES & SERVICES',

      sectionTitleA: 'Our',

      sectionTitleAccent: 'Services',

      sectionSub:
        'A complete offer to meet all your needs in electricity, renewables and energy performance.',

      projectTitle: 'Have a project?',

      projectSub:
        'Our team of experts is here to study your needs and propose the right solution.',

      trustTitleA: 'They also trust',

      trustTitleAccent: 'us…',
    },

    // =========================================================
    // SUB SERVICE
    // =========================================================
    subService: {
      badge: 'OUR EXPERTISE',

      heading: 'What we deliver for you',

      methodology: 'Methodology & support',

      solutions: 'Our solutions',

      sectors: 'Sectors we serve',

      quoteTitle: 'A project?',

      quoteSub:
        'Get a tailored study and a free quote within 24 hours.',
    },

    // =========================================================
    // ABOUT PAGE
    // =========================================================
    about: {
      pill: '+ OUR COMPANY',

      titleA: 'Energy experts',

      titleAccent: 'for over a decade',

      intro:
        'GPE – ENERGIES & SERVICES is a company specialised in a wide range of fields, offering forward-looking solutions for a sustainable energy supply.',

      bullets: [
        'Photovoltaic installations and renewables',
        'Industrial and commercial electrical works',
        'EV charging infrastructure',
      ],

      p2:
        'We support our clients with reliable technical and cost-effective solutions, designed to meet the energy challenges of today and tomorrow.',

      contact: 'Contact us',

      missionTitle: 'Our mission',

      missionText:
        'Supporting our clients through their energy transition with reliable, tailor-made technical solutions – from design to commissioning.',

      years: 'Years of experience',

      partners: 'Partners',

      presence: 'Nationwide presence',

      figuresBadge: '+ KEY FIGURES',

      figuresTitleA: 'Results that',

      figuresTitleAccent: 'speak',

      capBadge: '+ ORGANISATION & RESOURCES',

      capTitleA: 'Our capabilities &',

      capTitleAccent: 'expertise',

      capSub:
        'Human and technical resources dedicated to excellence on every one of your projects.',

      ctaTitleA: 'Have a project',

      ctaTitleAccent: 'in mind',

      ctaSub:
        'Our team is ready to study your project and propose a tailored solution, from design to commissioning.',
    },
  },

  // =========================================================
  // ARABIC
  // =========================================================
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      references: 'مراجعنا',
      international: 'دولي',
      contact: 'اتصل بنا',
      cta: 'طلب عرض سعر',
      openMenu: 'القائمة',
    },

    common: {
      learnMore: 'اكتشف المزيد',
      requestQuote: 'طلب عرض سعر',
      contactUs: 'اتصل بنا',
      callUs: 'اتصل بنا',
      backToServices: 'جميع خدماتنا',
      viewAll: 'عرض الكل',
      allProjects: 'جميع المشاريع',
      partners: 'الشركاء',
      certifications: 'الشهادات',
      relatedServices: 'الخدمات ذات الصلة',
    },

    hero: {
      pill: 'GPE · الطاقات والخدمات',
      titleA: 'الطاقة التي',
      titleAccent: 'تمنح الحياة',
      titleB: 'لممتلكاتكم.',
      subtitle:
        'الطاقات المتجددة، الحلول الشمسية ومحطات شحن السيارات الكهربائية: مستقبلكم، خبرتنا.',
      ctaContact: 'اتصل بنا',
      ctaServices: 'خدماتنا',

      stats: [
        {
          value: '10+',
          label: 'سنوات من الخبرة',
        },
        {
          value: '150+',
          label: 'عملاء راضون',
        },
        {
          value: '8',
          label: 'مجالات الخبرة',
        },
        {
          value: '100%',
          label: 'رضا العملاء',
        },
      ],
    },

    story: {
      badge: '+ من نحن',

      titleA: 'كهرباء المباني',

      titleAccent: 'والمساكن.',

      p1:
        'GPE – ENERGIES & SERVICES هي شركة متخصصة في مجموعة واسعة من المجالات، تقدم حلول المستقبل لتوفير طاقة مستدامة.',

      p2:
        'في القطاعين التجاري والصناعي، نرافق عملاءنا من خلال حلول تقنية واقتصادية تهدف إلى تعزيز الكفاءة وتقليل التكاليف. وبفضل خبرتنا في مجال الطاقات المتجددة، مثل الأنظمة الشمسية ومحطات شحن السيارات الكهربائية، نقدم حلولاً مخصصة تساعد الشركات والأفراد على الانتقال إلى مصادر طاقة صديقة للبيئة.',

      features: [
        {
          title: 'التحكم الكهربائي',
          desc:
            'متخصصون في إدارة وتشغيل شبكات البنية التحتية المتنوعة.',
        },
        {
          title: 'حلول مستدامة',
          desc:
            'حلول مستقبلية لتوفير طاقة مستدامة من خلال الطاقات المتجددة.',
        },
        {
          title: 'حلول مخصصة',
          desc:
            'حلول تقنية واقتصادية مصممة لتلبية احتياجات القطاعات التجارية والصناعية.',
        },
      ],

      bottomStats: [
        {
          value: '150+',
          label: 'عملاء راضون',
        },
        {
          value: '10+',
          label: 'موظفون',
        },
        {
          value: '10+',
          label: 'سنوات من الخبرة',
        },
      ],
    },

    servicesSection: {
      badge: '+ خبرتنا',

      titleA: 'حلول متكاملة،',

      titleB: 'من التصميم إلى التسليم.',

      subtitle:
        'ثمانية مجالات متكاملة لتلبية جميع احتياجاتكم في مجال الطاقة والمباني.',
    },
about: {
  heroTitleA: 'من',
  heroTitleAccent: 'نحن',
  heroSubtitle:
    'شريككم الموثوق في مجال الطاقات المتجددة والبنية التحتية الكهربائية.',

  companyBadge: '+ شركتنا',
  companyTitleA: 'خبراء في الطاقة',
  companyTitleAccent: 'منذ أكثر من عقد',
  companyTitleEnd: '.',

  companyP1:
    'GPE – ENERGIES & SERVICES هي شركة متخصصة في مجموعة واسعة من المجالات، تقدم حلولاً مستقبلية لتوفير طاقة مستدامة.',

  bullet1: 'التركيبات الكهروضوئية والطاقات المتجددة',
  bullet2: 'الأعمال الكهربائية الصناعية والتجارية',
  bullet3: 'البنية التحتية لشحن السيارات الكهربائية',

  companyP2:
    'نرافق عملاءنا من خلال حلول تقنية واقتصادية موثوقة مصممة لتلبية تحديات الطاقة الحالية والمستقبلية.',

  contactButton: 'اتصل بنا',

  missionTitle: 'مهمتنا',
  missionText:
    'مساعدة عملائنا في التحول نحو الطاقة المستدامة من خلال حلول تقنية موثوقة ومخصصة، من التصميم إلى التشغيل.',

  yearsExperience: 'سنوات من الخبرة',
  partners: 'شركاء',

  nationalPresence: 'حضور وطني',
  locations: 'فيترول · باريس · ليون · مرسيليا',

  figuresBadge: '+ أرقام رئيسية',
  figuresTitleA: 'نتائج',
  figuresTitleAccent: 'تتحدث عن نفسها',

  clientsLabel: 'عملاء راضون',
  clientsDesc:
    'محترفون وأفراد يثقون بنا في جميع أنحاء فرنسا.',

  projectsLabel: 'مشاريع منجزة',
  projectsDesc:
    'أكثر من 500 مشروع تم إنجازه بنجاح في القطاعات التجارية والصناعية والسكنية.',

  growthValue: 'نمو',
  growthLabel: 'مدروس ومستدام',
  growthDesc:
    'نمو منظم يعكس ثقة عملائنا المتجددة.',

  capabilitiesBadge: '+ التنظيم والموارد',
  capabilitiesTitleA: 'قدراتنا و',
  capabilitiesTitleAccent: 'خبراتنا',
  capabilitiesSubtitle:
    'موارد بشرية وتقنية مخصصة لتحقيق التميز في كل مشروع من مشاريعكم.',

  engineeringTitle: 'مكتب دراسات هندسية متكامل',
  engineeringDesc:
    'تصميم المشاريع وحساب الأحجام والمتابعة الفنية من الدراسة الأولية حتى التشغيل.',

  certifiedTitle: 'فرق فنية معتمدة',
  certifiedDesc:
    'متابعة تنفيذ مشاريعكم من خلال فرق مؤهلة ومعتمدة.',

  solarTitle: 'فرق متخصصة في الطاقة الشمسية',
  solarDesc:
    'فرق متخصصة في تركيب الأنظمة الكهروضوئية لتنفيذ سريع ومتوافق مع المعايير.',

  electricalTitle: 'فرق كهربائية',
  electricalDesc:
    'متخصصون في الأعمال الكهربائية التجارية والصناعية على شبكات الجهد المنخفض والمتوسط.',

  irveTitle: 'فرق شحن السيارات الكهربائية',
  irveDesc:
    'فرق معتمدة متخصصة في البنية التحتية لشحن السيارات الكهربائية.',

  ctaTitleA: 'لديكم مشروع',
  ctaTitleAccent: 'في ذهنكم',
  ctaText:
    'فريقنا مستعد لدراسة مشروعكم واقتراح حل مخصص لكم، من التصميم إلى التشغيل.',

  quoteButton: 'طلب عرض سعر',
},
    // =========================================================
    // SERVICES
    // =========================================================
    services: {
      'courants-forts': {
        title: 'التيارات القوية',
        desc: 'توزيع الكهرباء، لوحات الجهد المنخفض والمتوسط، الإضاءة ومعدات الطاقة للمباني التجارية والصناعية.',
      },
      'courants-faibles': {
        title: 'التيارات الضعيفة',
        desc: 'أنظمة الأمن والتحكم في الدخول وشبكات البيانات والمراقبة بالفيديو وأنظمة الاتصالات للبنية التحتية.',
      },
      'energies-renouvelables': {
        title: 'الطاقات المتجددة',
        desc: 'حلول الطاقة الكهروضوئية وتخزين البطاريات لتسريع الانتقال نحو مصادر الطاقة المستدامة.',
      },
      'mobilite-electrique': {
        title: 'التنقل الكهربائي',
        desc: 'حلول شحن السيارات الكهربائية، من محطات الشحن المنزلية إلى محطات الشحن السريع.',
      },
      'renovation-energetique': {
        title: 'تجديد كفاءة الطاقة',
        desc: 'التدقيق والاستشارات وأعمال التجديد لتقليل استهلاك الطاقة وتحسين قيمة المباني بشكل مستدام.',
      },
      'chauffage-climatisation': {
        title: 'التدفئة وتكييف الهواء',
        desc: 'حلول متكاملة لأنظمة التدفئة والتهوية وتكييف الهواء، من التركيب إلى الصيانة.',
      },
      'vrd': {
        title: 'الطرق والشبكات المختلفة',
        desc: 'أعمال الطرق وشبكات المرافق والتجهيزات الخارجية، بما في ذلك أعمال الحفر وتصريف المياه والبنية التحتية للمواقع.',
      },
      'bureau-etudes': {
        title: 'مكتب الدراسات الهندسية',
        desc: 'الهندسة الكهربائية والتصميم والحسابات الفنية ومتابعة تنفيذ المشاريع في مجال الطاقة.',
      },
    },

    projectsSection: {
      badge: '+ مراجعنا',

      titleA: 'يثقون',

      titleAccent: 'بنا.',

      subtitle:
        'تثق بنا كبرى مجموعات البناء والاتصالات والطاقة لإنجاز مشاريعها في جميع أنحاء فرنسا.',

      viewAll: 'عرض جميع المراجع',

      discover: 'اكتشف جميع مشاريعنا',
    },

    certifications: {
      tagline: 'GPE ÉNERGIES & SERVICES',

      titleA: 'شهاداتنا',

      titleAccent: '',
    },

    footer: {
      about:
        'الطاقة التي تمنح الحياة لممتلكاتكم. خبراء في التركيبات الكهربائية والطاقات المتجددة وحلول التدفئة والتكييف.',

      navigation: 'التنقل',

      services: 'خدماتنا',

      contact: 'اتصل بنا',

      response: 'الرد خلال 24 ساعة عمل',

      rights: 'جميع الحقوق محفوظة.',

      legal: 'الإشعارات القانونية',

      privacy: 'سياسة الخصوصية',

      cookies: 'ملفات تعريف الارتباط',
    },

    contact: {
      pill: 'اتصل بنا',

      titleA: 'لنتحدث عن',

      titleAccent: 'مشروعكم.',

      subtitle:
        'يرد فريقنا خلال 24 ساعة عمل. سواء كنتم بحاجة إلى عرض سعر أو دراسة جدوى أو استفسار تقني، نحن هنا للاستماع إليكم.',

      phone: 'الهاتف',

      email: 'البريد الإلكتروني',

      address: 'العنوان',

      hours: 'ساعات العمل',

      weekdays: 'الإثنين – الجمعة',

      weekend: 'السبت – الأحد',

      closed: 'مغلق',

      responseTitle: 'الرد خلال 24 ساعة عمل',

      responseSub: 'سيقوم مستشار متخصص بالتواصل معكم سريعاً.',

      formBadge: 'GPE – الطاقات والخدمات',

      formTitleA: 'تواصلوا',

      formTitleAccent: 'معنا.',

      formSub:
        'املأوا النموذج وسنعاود الاتصال بكم خلال 24 ساعة عمل.',

      fullName: 'الاسم الكامل',

      emailLabel: 'البريد الإلكتروني',

      phoneLabel: 'الهاتف',

      company: 'الشركة',

      service: 'الخدمة المطلوبة',

      selectService: 'اختر خدمة',

      otherRequest: 'طلب آخر',

      yourMessage: 'رسالتكم',

      messagePlaceholder:
        'صفوا مشروعكم أو طلبكم…',

      send: 'إرسال الرسالة',

      success:
        'تم إرسال الرسالة بنجاح. سنقوم بالرد عليكم قريباً.',

      policy:
        'بإرسال هذا النموذج، فإنكم توافقون على سياسة الخصوصية الخاصة بنا.',
    },

    international: {
      pill: 'حضور عالمي',

      titleA: 'ما وراء',

      titleAccent: 'الحدود.',

      subtitle:
        'ترافق GPE Énergies & Services المشاريع الكبرى في فرنسا وعلى المستوى الدولي، من خلال خبرتها التقنية في مجال الكهرباء والطاقات المتجددة في مختلف أنحاء العالم.',

      stats: [
        {
          value: '2',
          label: 'قارتان',
        },
        {
          value: '2+',
          label: 'دول مغطاة',
        },
        {
          value: '150+',
          label: 'مشروعاً منجزاً',
        },
        {
          value: '10+',
          label: 'شركاء دوليون',
        },
      ],

      officesBadge: '+ مكاتبنا',

      officesTitleA: 'حضور في',

      officesTitleAccent: 'قارتين',

      officesSub:
        'تعمل فرقنا من فرنسا والمملكة العربية السعودية لتغطية أوروبا ومنطقة الخليج.',

      partnersBadge: '+ شركاؤنا الدوليون',

      partnersTitleA: 'تحالفات',

      partnersTitleAccent: 'استراتيجية',

      certificationsBadge: 'الشهادات والمؤهلات',

      certificationsTitleA: 'معتمدون. موثوقون.',

      certificationsTitleAccent: 'يمكن الاعتماد علينا.',

      ctaTitle: 'مشروع دولي؟',

      ctaSub:
        'تواصلوا مع أقرب مكتب لدراسة مشروعكم، في أي قارة.',

      hq: 'المقر الرئيسي',

      regional: 'المكتب الإقليمي – الخليج',
    },

    references: {
      pill: 'مراجعنا',

      titleA: 'مشاريع',

      titleAccent: 'تتحدث عن نفسها.',

      subtitle:
        'أكثر من 500 مشروع تم إنجازه لصالح جهات عامة وخاصة في جميع أنحاء فرنسا.',

      featuredBadge: '+ مشاريع مميزة',

      featuredTitleA: 'أبرز',

      featuredTitleAccent: 'إنجازاتنا',

      featuredSub:
        'مجموعة مختارة من أبرز مشاريعنا، تعكس خبرتنا الميدانية.',

      partnersTagline: 'GPE – الطاقات والخدمات',

      partnersTitleA: 'هم أيضاً يثقون',

      partnersTitleAccent: 'بنا',

      partnersSub:
        'تثق بنا كبرى مجموعات البناء والاتصالات والطاقة لإنجاز مشاريعها.',

      ctaTitle: 'لديكم مشروع مماثل؟',

      ctaSub:
        'لنتحدث عن مشروعكم. يرد فريق خبرائنا خلال 24 ساعة عمل.',
    },

    servicesPage: {
      pill: 'GPE · الطاقات والخدمات',

      titleA: 'حلول متكاملة',

      titleAccent: 'لمشاريعكم في مجال الطاقة.',

      subtitle:
        'نرافق الشركات والجهات المحلية والقطاعات الصناعية بحلول موثوقة ومبتكرة ومستدامة.',

      sectionTagline: 'GPE · الطاقات والخدمات',

      sectionTitleA: 'خدماتنا',

      sectionTitleAccent: '',

      sectionSub:
        'عرض متكامل لتلبية جميع احتياجاتكم في الكهرباء والطاقات المتجددة وكفاءة الطاقة.',

      projectTitle: 'لديكم مشروع؟',

      projectSub:
        'فريق خبرائنا على استعداد لدراسة احتياجاتكم واقتراح الحل المناسب.',

      trustTitleA: 'هم أيضاً يثقون',

      trustTitleAccent: 'بنا…',
    },

    subService: {
      badge: 'خبرتنا',

      heading: 'ما نقدمه لكم',

      methodology: 'المنهجية والمرافقة',

      solutions: 'حلولنا',

      sectors: 'قطاعات التدخل',

      quoteTitle: 'لديكم مشروع؟',

      quoteSub:
        'احصلوا على دراسة مخصصة وعرض سعر مجاني خلال 24 ساعة.',
    },

    about: {
      pill: '+ شركتنا',

      titleA: 'خبراء في الطاقة',

      titleAccent: 'منذ أكثر من عقد',

      intro:
        'GPE – ÉNERGIES & SERVICES هي شركة متخصصة في مجموعة واسعة من المجالات، تقدم حلول المستقبل لتوفير طاقة مستدامة.',

      bullets: [
        'تركيبات الطاقة الشمسية الكهروضوئية والطاقات المتجددة',
        'الأعمال الكهربائية الصناعية والتجارية',
        'البنية التحتية لشحن السيارات الكهربائية',
      ],

      p2:
        'نرافق عملاءنا بحلول تقنية واقتصادية موثوقة، مصممة للاستجابة لتحديات الطاقة اليوم والغد.',

      contact: 'اتصلوا بنا',

      missionTitle: 'مهمتنا',

      missionText:
        'مرافقة عملائنا في انتقالهم إلى الطاقة المستدامة من خلال حلول تقنية موثوقة ومخصصة – من التصميم إلى التشغيل.',

      years: 'سنوات من الخبرة',

      partners: 'الشركاء',

      presence: 'حضور وطني',

      figuresBadge: '+ أرقام رئيسية',

      figuresTitleA: 'نتائج',

      figuresTitleAccent: 'تتحدث عن نفسها',

      capBadge: '+ التنظيم والموارد',

      capTitleA: 'قدراتنا و',

      capTitleAccent: 'خبرتنا',

      capSub:
        'موارد بشرية وتقنية مخصصة للتميز في كل مشروع من مشاريعكم.',

      ctaTitleA: 'لديكم مشروع',

      ctaTitleAccent: 'في ذهنكم',

      ctaSub:
        'فريقنا مستعد لدراسة مشروعكم واقتراح حل مخصص، من التصميم إلى التشغيل.',
    },
  },
};
